import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SearchBar, Pagination } from "../../components";
import { openModal, closeModal } from "../../store/slices/addModalSlice";
import TableItemsExams from "../TableItemsExams/TableItemsExams";
import {
  fetchDataExams,
  createDataExams,
  setPage,
} from "../../store/slices/apiExamsSlice";
import AddModalExams from "../Modals/AddModalExams";
import TableItemsExamsResponsive from "../TableItemsExams/TableItemsExamsResponsive";

const TableExams = () => {
  const dispatch = useDispatch();
  const totalCount = useSelector((state) => state.apiExams.totalCount);
  const dataExams = useSelector((state) => state.apiExams.data);
  const currentPage = useSelector((state) => state.apiExams.currentPage);
  const isOpen = useSelector((state) => state.addModal.isOpen);
  const [searchInput, setSearchInput] = useState("");
  const prevSearchRef = useRef("");

  useEffect(() => {
    const pageToUse = prevSearchRef.current !== searchInput ? 1 : currentPage;

    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1));
      prevSearchRef.current = searchInput;
    }

    dispatch(fetchDataExams({ page: pageToUse, searchQuery: searchInput }));
  }, [dispatch, currentPage, searchInput]);

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const openAddModal = () => {
    dispatch(openModal());
  };
  const handleAddExams = (data) => {
    dispatch(createDataExams(data));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(fetchDataExams({ page: currentPage, searchQuery: searchInput }));
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  const handleEditSuccess = () => {
    dispatch(fetchDataExams({ page: currentPage, searchQuery: searchInput }));
  };

  return (
    <div className="p-3">
      <div className="flex flex-col sm:flex-row items-center justify-between pb-4 bg-white dark:bg-gray-900 gap-3">
        <div className="flex-grow w-full sm:w-auto">
          <SearchBar
            searchInput={searchInput}
            handleSearchInputChange={handleSearchInputChange}
            handleSearchSubmit={handleSearchSubmit}
          />
        </div>
        <div>
          <button
            onClick={openAddModal}
            className="text-white  bg-blue-500 rounded-md border px-3 py-2"
            alt="you can edit here"
          >
            Shto Test
          </button>
        </div>
      </div>

      {isOpen && (
        <AddModalExams
          title="Shto një test"
          submitButtonText="Shto testin"
          onSubmit={handleAddExams}
          inputLabel1="Emri i testit"
          inputLabel2="Zgjedh kategorinë"
          premiumStatus="A eshte premium"
          onClose={handleCloseModal}
          onSuccess={handleEditSuccess}
        />
      )}

      <div
        className="relative overflow-x-auto shadow-md sm:rounded-lg"
        style={{ borderRadius: 1 }}
      >
        <div className="hidden sm:block">
          <table className="min-w-full table-auto text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-3 sm:px-6 py-3 whitespace-nowrap">
                  Lista e Testeve
                </th>
                <th scope="col" className="px-3 sm:px-6 py-3 whitespace-nowrap">
                  Kategoria
                </th>
                <th scope="col" className="px-3 sm:px-6 py-3 whitespace-nowrap">
                  Premium
                </th>
                <th scope="col" className="px-3 sm:px-6 py-3 whitespace-nowrap">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <TableItemsExams
                dataExams={dataExams}
                showCity={false}
                showCategory={false}
                onEditSuccess={handleEditSuccess}
              />
            </tbody>
          </table>
        </div>
        <div className="block sm:hidden space-y-4">
          <TableItemsExamsResponsive
            dataExams={dataExams}
            showCity={false}
            showCategory={false}
            onEditSuccess={handleEditSuccess}
          />
        </div>

        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default TableExams;
